import { modals } from '../manager';

export const heartbeat = async () => {
  return {
    timestamp: Date.now(),
    active: Object.values(modals).some((m) => m.isPresenting),
  };
};
